import throttle from 'lodash/throttle';

export default class {
  constructor($c) {
    this.$c = $c.jquery ? $c.get(0) : $c;
    this.check();
    window.addEventListener('resize', throttle(this.check.bind(this), 500));
  }

  check() {
    const $menu = this.$c;
    const $moreButton = $menu.querySelector('.js-minimize-more');
    const $moreList = $menu.querySelector('.js-minimize-more-list');
    const maxWidth = $menu.offsetWidth - 60;
    let width = 0;
    let hideFrom = 0;

    $menu.append(...$moreList.querySelectorAll('.js-minimize-item'));

    const items = $menu.querySelectorAll('.js-minimize-item');
    items.forEach((element, index) => {
      if (width + element.offsetWidth < maxWidth) {
        hideFrom = index;
      }
      width += element.offsetWidth;
    });
    if (hideFrom < items.length - 1) {
      const itemsArr = [...items];
      $moreList.append(...itemsArr.slice(hideFrom));
      $moreButton.style.display = 'block';
    } else {
      $moreButton.style.display = 'none';
    }
    if ($menu.classList.contains('_overflow')) $menu.classList.remove('_overflow');
  }
}
